<template>
  <p class="text-sm text-gray-600 mt-2">
    Importante: Use seu nome completo de batismo, não o nome de casado(a)
  </p>
</template>